import RouteRepository from "@domain/repositories/RouteRepository";
import UseCase from "@domain/UseCase";
import { Route } from "@domain/models/Route";

type Input = Partial<Route>;

type Output = Promise<Route>;

export class CreateRouteUseCase implements UseCase<Input, Output> {
  constructor(private readonly routeRepository: RouteRepository) {}

  execute(data: Input) {
    return this.routeRepository.create(data);
  }
}
